import React from 'react';

const FeatureSection: React.FC = () => {
  // Datos quemados para las características
  const features = [
    {
      id: 1,
      icon: "document",
      title: "Automatización IA",
      description: "Nuestro sistema utiliza la Inteligencia Artificial para automatizar procesos, lo que nos permite ofrecer servicios de manera más eficiente y precisa."
    },
    {
      id: 2,
      icon: "calendar",
      title: "Calidad en los servicios",
      description: "Nuestros proevedores pasan por un riguroso proceso de aceptación con el fin de ofrecer servicios de calidad"
    },
    {
      id: 3,
      icon: "users",
      title: "Elección a tu medida",
      description: "Nuestro asistente IA te dará las mejores opciones segun tu necesidad, eligiendo el que más se ajuste a tus expectativas."
    }
  ];

  // Función para renderizar el icono adecuado
  const renderIcon = (iconType: string) => {
    switch (iconType) {
      case 'document':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        );
      case 'calendar':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        );
      case 'users':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="py-6 md:py-10">
      <div className="container mx-auto px-4 md:px-12">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-white mb-4">
            Todo en uno <span className="text-xervix-primary">Servicios para el hogar.</span>
          </h2>
          <p className="text-gray-600 text-left dark:text-gray-300 max-w-3xl mx-auto">
            XERVIX es una plataforma inteligente que reúne todo lo que necesitas para encontrar, agendar y gestionar
            servicios del hogar de forma rápida, confiable y sin complicaciones. Desde una reparación urgente hasta una
            remodelación completa, XERVIX lo hace fácil.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
          {features.map((feature) => (
            <div key={feature.id} className="bg-white dark:bg-xervix-bg-secondary-dark rounded-xl p-2 md:p-8 flex flex-col items-center">
              <div className="bg-xervix-primary rounded-full p-4 mb-4 md:p-6">
                {renderIcon(feature.icon)}
              </div>
              <h3 className="text-xl font-bold text-white text-center mb-2 md:mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm text-center">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureSection;
